import React, { useState, useRef, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { Prompt } from "react-router";
import {
  Box,
  Typography,
  LinearProgress,
  Button,
  Icon,
  Grid,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  DialogContentText,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import * as Icons from "@material-ui/icons";
import clsx from "clsx";
import { useSelector, shallowEqual } from "react-redux";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  GET_RESULTS,
  SET_QUIZ_PROGRESS,
  RESET_QUIZ_PROGRESS,
} from "../_redux/quizCrud";
import { useDispatch } from "react-redux";

import { quizResultsSlice } from "../../quiz/_redux/quizSlice";

const { actions } = quizResultsSlice;

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 15,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "primary",
  },
}))(LinearProgress);

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  whiteBackground: {
    backgroundColor: "white",
  },
});

export function QuizPage() {
  const dispatch = useDispatch();
  const mounted = useRef();

  const classes = useStyles();
  const history = useHistory();

  const { user } = useSelector((state) => state.auth);

  const localAnswers = localStorage.getItem("quiz-answers");

  const { questions, quizResults } = useSelector(
    (state) => state,
    shallowEqual
  );

  const [quizCompleted, setQuizCompleted] = useState(false);
  const [answeredCount, setAnsweredCount] = useState(
    quizResults.answers ? quizResults.answers.length : 0
  );
  const [showAlert, setShowAlert] = useState(false);
  console.log(quizResults.answers.length);
  console.log(localAnswers && localAnswers.length);
  const [open, setOpen] = useState(
    quizResults.answers.length || (localAnswers && localAnswers.length)
      ? true
      : false
  );

  const [saveQuizProgress, { loading: quizProgressLoading }] = useMutation(
    SET_QUIZ_PROGRESS
  );
  const [resetQuiz, { loading: resetLoading }] = useMutation(
    RESET_QUIZ_PROGRESS
  );

  const retakeQuiz = async () => {
    localStorage.setItem("quiz-answers", "");
    await resetQuiz(RESET_QUIZ_PROGRESS);
    setAnsweredCount(0);
    history.replace("/");
  };

  const [fetchResults, { loading }] = useLazyQuery(GET_RESULTS, {
    onCompleted: (data) => {
      dispatch(actions.setAnswers({ answers: answers.join("") }));
      dispatch(actions.resultsFetched({ results: data.results.result }));
      localStorage.setItem("quiz-questions", "");
      localStorage.setItem("quiz-answers", "");
      setAnsweredCount(0);
      history.push("/results");
    },
  });

  const initializeAnswers = (answers, questions) => {
    if (
      !localAnswers ||
      !localAnswers.length ||
      !answers ||
      answers.length === 0
    ) {
      return Array.apply(null, { length: questions.length }).map(
        Function.call,
        () => 0
      );
    } else {
      if (localAnswers.length && (!answers || !answers.length)) {
        answers = localAnswers;
      }
      let res = [];
      const temp = answers.split("");
      questions.forEach((question, index) => {
        if (index < answers.length) {
          res.push(Number(temp[index]));
        } else {
          res.push(0);
        }
      });
      return res;
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  let allQuestions = questions.questions;
  const [answers, setAnswers] = useState(
    initializeAnswers(quizResults.answers, allQuestions)
  );

  const selectAnswer = (answerIndex, changedAnswer) => {
    let modifiedAnswers = [];
    let answersCount = 0;
    answers.forEach((answer, index) => {
      let finalAnswer;
      if (answerIndex - 1 === index) finalAnswer = changedAnswer;
      else finalAnswer = answer;
      modifiedAnswers.push(finalAnswer);
      if (finalAnswer > 0) {
        answersCount++;
      }
    });
    setAnsweredCount(answersCount);
    setAnswers(modifiedAnswers);
    localStorage.setItem("quiz-answers", modifiedAnswers.join(""));
  };

  const [page, setPage] = useState(1);
  const [currentPageQuestions, setCurrentPage] = useState(
    allQuestions.slice((page - 1) * 5, page * 5)
  );

  if (!questions.questions.length) {
    history.push("/");
  }

  useEffect(() => {
    if (!mounted.current) {
      // do componentDidMount logic
      mounted.current = false;
    } else {
      // do componentDidUpdate logic
      window.onbeforeunload = () => answeredCount > 0;
    }
  });

  return (
    <Box
      display="flex"
      flexDirection="column"
      className={clsx(classes.root, classes.whiteBackground)}
      p={5}
    >
      <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        keepMounted
        open={open}
      >
        <DialogTitle id="simple-dialog-title">
          Continue from where you left?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            You have an unfinished questionaire. Click on continue to continue
            the questionaire OR click on restart to start fresh.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              dispatch(actions.resetAnswers());
              retakeQuiz();
            }}
            color="secondary"
            disabled={resetLoading}
          >
            {resetLoading ? (
              <CircularProgress style={{ color: "#3699FF" }} color="#3699FF" />
            ) : (
              "Restart"
            )}
          </Button>
          <Button
            onClick={handleClose}
            style={{ color: "#3699FF", borderColor: "#3699FF" }}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
      <Prompt
        when={!user && !quizCompleted && answeredCount > 0}
        message="Your responses will be lost, are you sure you want to leave?"
      />
      <Box className={classes.whiteBackground}>
        <Typography variant="h5">Interest Profiler: Questionaire</Typography>
        <Box display="flex" m={1} mb={2}>
          <Box display="flex" mx={1}>
            <Box mr={1}>
              <i className="fa fa-clock mr-1" aria-hidden="true"></i>
            </Box>
            Take your time
          </Box>
          |
          <Box mx={1} display="flex">
            <Box mr={1}>
              <i className="fa fa-comment-dots" aria-hidden="true"></i>
            </Box>
            Think each question through
          </Box>
          |
          <Box ml={1} display="flex">
            <Box mr={1}>
              <i className="fa fa-balance-scale" aria-hidden="true"></i>
            </Box>
            There are no right or wrong answers
          </Box>
        </Box>
        <Typography variant="h6">
          Select the option that best reflects how you would feel performing the
          activity below.
        </Typography>
      </Box>
      <Box display="flex">
        <Box
          display="flex"
          flexDirection="row"
          width="100%"
          mt={3}
          justifyContent="center"
        >
          <Typography variant="h6">Progress</Typography>
          <Box width="70%" mx={3} mt={1}>
            <BorderLinearProgress
              variant="determinate"
              value={(answeredCount / allQuestions.length) * 100}
            />
          </Box>
          <Typography variant="h6">{`Completed ${answeredCount}/${allQuestions.length}`}</Typography>
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" alignItems="center" mt={5}>
        {currentPageQuestions.map((item, index) => (
          <Box key={item.index} mb={2}>
            <Box fontSize={16} fontWeight={500}>
              {item.index}. {item.text}
            </Box>{" "}
            <hr />
            <Box
              display="flex"
              flexDirection="row"
              alignItems="flex-start"
              // m={2}
              textAlign="center"
              flexWrap="wrap"
              justifyContent="center"
            >
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                mr={5}
                onClick={() => {
                  answers[item.index - 1] !== 1 && selectAnswer(item.index, 1);
                }}
                style={{ cursor: "pointer" }}
              >
                <Icon
                  className={clsx("fa fa-frown-open")}
                  style={
                    answers[item.index - 1] === 1
                      ? { fontSize: 50, color: "#f44336" }
                      : { fontSize: 50 }
                  }
                />
                Strongly dislike
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                mr={5}
                onClick={() => {
                  answers[item.index - 1] !== 2 && selectAnswer(item.index, 2);
                }}
                style={{ cursor: "pointer" }}
              >
                <Icon
                  className={clsx("fa fa-frown")}
                  style={
                    answers[item.index - 1] === 2
                      ? { fontSize: 50, color: "#ff9800" }
                      : { fontSize: 50 }
                  }
                />
                Dislike
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                mr={5}
                onClick={() => {
                  answers[item.index - 1] !== 3 && selectAnswer(item.index, 3);
                }}
                style={{ cursor: "pointer" }}
              >
                <Icon
                  className={clsx("fa fa-meh")}
                  style={
                    answers[item.index - 1] === 3
                      ? { fontSize: 50, color: "#fdd835" }
                      : { fontSize: 50 }
                  }
                />
                Unsure
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                mr={5}
                onClick={() => {
                  answers[item.index - 1] !== 4 && selectAnswer(item.index, 4);
                }}
                style={{ cursor: "pointer" }}
              >
                <Icon
                  className={clsx("fa fa-smile")}
                  style={
                    answers[item.index - 1] === 4
                      ? { fontSize: 50, color: "#8bc34a" }
                      : { fontSize: 50 }
                  }
                />
                Like
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                mr={5}
                onClick={() => {
                  answers[item.index - 1] !== 5 && selectAnswer(item.index, 5);
                }}
                style={{ cursor: "pointer" }}
              >
                <Icon
                  className={clsx("fa fa-grin")}
                  style={
                    answers[item.index - 1] === 5
                      ? { fontSize: 50, color: "#4caf50" }
                      : { fontSize: 50 }
                  }
                />
                Strongly like
              </Box>
            </Box>
          </Box>
        ))}
        <Box width="100%">
          <Grid container justify="space-between">
            <Grid item xs={false} md={3}></Grid>
            <Grid item xs={12} md={6}>
              {showAlert && (
                <Box m={2}>
                  <Alert variant="filled" severity="warning">
                    Please select an option to all 5 questions above
                  </Alert>
                </Box>
              )}
              {}
              <Box display="flex" justifyContent="space-between">
                <Button
                  variant="contained"
                  // style={{ background: "#3699FF", borderColor: "#3699FF" }}
                  disableElevation
                  startIcon={<Icons.ArrowLeft style={{ color: "white" }} />}
                  disabled={page === 1}
                  color={page === 1 ? "" : "secondary"}
                  onClick={() => {
                    setPage(page - 1);
                    setCurrentPage(
                      allQuestions.slice((page - 2) * 5, (page - 1) * 5)
                    );
                    setShowAlert(false);
                    window.scrollTo(0, 0);
                  }}
                >
                  <Typography style={{ color: "white" }}> Previous</Typography>
                </Button>
                <Button
                  variant="contained"
                  color={"secondary"}
                  disableElevation
                  endIcon={
                    !(allQuestions.length / 5 === page) && (
                      <Icons.ArrowRight style={{ color: "white" }} />
                    )
                  }
                  onClick={() => {
                    if (page * 5 > answeredCount) {
                      setShowAlert(true);
                    } else if (allQuestions.length / 5 !== page) {
                      saveQuizProgress({
                        variables: {
                          setQuizProgressAnswers: answers.join(""),
                        },
                      });
                      setPage(page + 1);
                      setCurrentPage(
                        allQuestions.slice(page * 5, (page + 1) * 5)
                      );
                      setShowAlert(false);
                      window.scrollTo(0, 0);
                    } else if (allQuestions.length / 5 === page) {
                      saveQuizProgress({
                        variables: {
                          setQuizProgressAnswers: answers.join(""),
                        },
                      });
                      setQuizCompleted(true);
                      setShowAlert(false);
                      fetchResults({
                        variables: { resultsAnswers: answers.join("") },
                      });
                    }
                  }}
                  disabled={loading || quizProgressLoading}
                >
                  {loading || quizProgressLoading ? (
                    <CircularProgress
                      style={{ color: "#3699FF" }}
                      size={20}
                      style={{ color: "white" }}
                    />
                  ) : (
                    <Typography style={{ color: "white" }}>
                      {allQuestions.length / 5 === page ? "submit" : "NEXT"}
                    </Typography>
                  )}
                </Button>
              </Box>
            </Grid>
            <Grid item xs={false} md={3}></Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
